export default __webpack_public_path__ + "static/media/ic-check-filled.12c10e71.svg";